/** @flow */

export const ReportLogTypes = {
  ABSENCE_DETAILS: "ABSENCE_DETAILS",
  RTW_DETAILS: "RTW_DETAILS",
  ALERT_DETAILS: "ALERT_DETAILS",
  ABSENCE_REASON_TRENDS: "ABSENCE_REASON_TRENDS",
  ABSENCE_RATE_TRENDS: "ABSENCE_RATE_TRENDS",
  COMPLIANCE_TRENDS: "COMPLIANCE_TRENDS",
  EMPLOYEE_FOCUS_LIST: "EMPLOYEE_FOCUS_LIST",
  ORGANISATIONAL_UNIT_FOCUS_LIST: "ORGANISATIONAL_UNIT_FOCUS_LIST",
  MANAGER_FOCUS_LIST: "MANAGER_FOCUS_LIST",
  ABSENCE_MONITORING_DETAILS: "ABSENCE_MONITORING_DETAILS",
};
export const ReportActionTypesEnums = {
  COPY: "COPY",
  RENAME: "RENAME",
  DELETE: "DELETE",
};

export const answerTypesEnum = {
  FREE_TEXT: "TEXT",
  DATE_PICK: "DATE",
  SINGLE_SELECT: "TEXT",
  MULTI_SELECT: "TEXT_LIST",
  CONFIRMATION: "BOOLEAN",
};

export const ReportModalStepTypes = {
  FILTERS: "filters",
  COLUMNS: "columns",
  TABLE: "table",
};

export const WEEKLY = "WEEKLY";

export const COLOR_BY_ACTIVITY_CODE = {
  ALERT: "yellow", // alert
  "ABSENCE-U": "grey", // updated
  "ABSENCE-UC": "green", // closed
  "ABSENCE-OU": "red", // new
  "ABSENCE-OUC": "green", // opened and closed
  RTW: "orange", // rtw
  NOTE: "blue", // note added
  DOCUMENT: "purple", // document uploaded
  MONITORING: "pink", // monitoring review
};

export const ACTIVITY_FEED_TYPES = {
  ABSENCEOU: "ABSENCE-OU", //New Absence
  ABSENCEUC: "ABSENCE-UC", // Closed Absence
  ABSENCEOUC: "ABSENCE-OUC", //Absence Opened and Closed
  ABSENCEU: "ABSENCE-U", // TODO check with the BE if this still exist
  NOTE: "NOTE",
  DOCUMENT: "DOCUMENT",
  RTW: "RTW",
  ALERT: "ALERT",
};

export const SUPPLIER_REFERRAL_REPORT_TYPE = {
  NEW_REFERRALS: "NEW_REFERRALS",
  ACTIVE_REFERRALS: "ACTIVE_REFERRALS",
  CLOSED_REFERRALS: "CLOSED_REFERRALS",
};

export const SUPPLIER_REFERRAL_STATUSES = {
  ACTIVE: "ACTIVE",
  INAPPROPRIATE_REFERRAL: "INAPPROPRIATE_REFERRAL",
  ALL: "ALL",
};

export const SUPPLIER_REFERRAL_REPORT_ACTION_TYPE = {
  ACCEPT_REFUSE: "ACCEPT_REFUSE",
  ACKNOWLEDGE: "ACKNOWLEDGE",
};

export const PERCENTAGE = "PERCENTAGE";

export const COMPLETE_SUPPORT = "COMPLETE_SUPPORT";

export const HEALTH_REPORTS_DATE_RANGES = {
  YESTERDAY: "YESTERDAY",
  LAST_7_DAYS: "LAST_7_DAYS",
  LAST_30_DAYS: "LAST_30_DAYS",
  LAST_12_MONTHS: "LAST_12_MONTHS",
  CUSTOM: "CUSTOM",
};

export const DATA_TYPES = {
  CATEGORY: "CATEGORY",
  ABSENCE_REASON: "ABSENCE_REASON",
  TIME_OF_DAY: "TIME_OF_DAY",
  ACTIVITY: "ACTIVITY",
};

export const ASSESSMENT_DATA_TYPES = {
  HEALTH_ISSUE: "HEALTH_ISSUE",
  DEPARTMENT: "DEPARTMENT",
  ABSENCE_LENGTH: "ABSENCE_LENGTH",
  AGE_GROUP: "AGE_GROUP",
};

export const ADVICES_DATA_TYPES = {
  ALL: "ALL",
  ILLNESS: "ILLNESS",
  MIND: "MIND",
  CRISIS: "CRISIS",
};

export const REPORT_TYPES = {
  DEPARTMENT: "DEPARTMENT",
  TRIGGER: "TRIGGER",
  ABSENCE_REASON: "ABSENCE_REASON",
  ABSENCE_LENGTH: "ABSENCE_LENGTH",
};

export const KPI_MANAGER_REPORT_ORDERS = {
  MOST_REFERRALS_ACTIONED: "MOST_REFERRALS_ACTIONED",
  MOST_APPROVALS: "MOST_APPROVALS",
  HIGHEST_COMPLIANCE: "HIGHEST_COMPLIANCE",
};

export const enabledReports = {
  // Absence Details
  "Current Open Absences": "AD_COVER_CURRENT_OPEN_TITLE",
  "Absences Started in Last 7 Days": "AD_COVER_STARTED_LAST_WEEK",
  "Mental Health Absences in Last 12 Months": "AD_COVER_MENTAL_LAST_YEAR",
  "Musculoskeletal Absences in Last 12 Months": "AD_COVER_MUSCULOSKELETAL_LAST_YEAR",
  "New Absences Today": "AD_COVER_NEW_TODAY",
  "Absences Closed Today": "AD_COVER_CLOSED_TODAY",
  "Absences Started in Last 30 Days": "ABSENCES_COVER_STARTED_LAST_MONTH",
  "Absences Started in Last 12 Months": "ABSENCES_COVER_STARTED_LAST_YEAR",

  // Alert Details
  "Today's Alerts": "ALERTS_TODAYS",
  "Alerts in the Last 7 Days": "ALERTS_LAST_WEEK",
  "Alerts in the Last 30 Days": "ALERTS_LAST_MONTH",
  "Alerts in the Last 90 Days": "ALERTS_LAST_QUARTER",

  "% Absence Rate in Last 12 Months": "ART_MONTHLY_TRENDS_LAST_YEAR",
  "Working Days Lost in Last 12 Months": "ART_DAYS_LOST_LAST_YEAR",
  "Absence Spells Started in Last 12 Months": "ART_ABSENCE_SPELLS_LAST_YEAR",
  "DLPE in Last 12 Months": "ART_DLPE_LAST_YEAR",
  "BV12 FTE Available in Last 12 Months": "ART_BV12_FTE_LAST_YEAR",
  "BV12 Score in Last 12 Months": "ART_BV12_SCORE_LAST_YEAR",
  "Working Hours Lost in Last 12 Months": "ART_WORKING_HOURS_LAST_YEAR",
  "Hours Available in Last 12 Months": "ART_WORKING_HOURS_AVAILABLE_LAST_YEAR",
  "Working Days Available in Last 12 Months": "ART_WORKING_DAYS_AVAILABLE_LAST_YEAR",
  "Headcount in Last 12 Months": "ART_HEADCOUNT_LAST_YEAR",
  "Cost of Absence in Last 12 Months": "ART_COST_OF_ABSENCE_LAST_YEAR",

  // RTW
  "All Outstanding RTW Interviews": "RTW_ALL_OUTSTANDING_INTERVIEWS",
  "RTW Completed in Last 7 Days": "RTW_COMPLETED_LAST_WEEK",
  "RTW Completed in Last 30 Days": "RTW_COMPLETED_LAST_MONTH",
  "Expired RTWs in Last 6 Months": "RTW_COMPLETED_LAST_SIX_MONTH",

  // Absence Reason
  "Working Days Lost in the Last 12 Months": "AR_WORKING_DAYS_LOST_LAST_YEAR",
  "Absence Spells in the Last 12 Months": "AR_ABSENCE_SPELLS_LAST_YEAR",
  "Average Absence Length in the Last 12 Months": "AR_ABSENCE_LENGTH_LAST_YEAR",
  "RTW Compliance in the Last 12 Months": "AR_RTW_COMPLIANCE_LAST_YEAR",
  "DLPE in the Last 12 Months": "AR_DLPE_LAST_YEAR",
  "Cost of Absence in the Last 12 Months": "AR_COSTS_LAST_YEAR",
  "Short Term Spells in Last 12 Months": "AR_SHORT_SPELLS_LAST_YEAR",
  "Long Term Spells in Last 12 Months": "AR_LONG_SPELLS_LAST_YEAR",

  // Compliance Trends
  "RTW Compliance in Last 12 Months": "CT_RTW_COMPLIANCE_LAST_YEAR",
  "RTW Compliance in Last 24 Months": "CT_RTW_COMPLIANCE_LAST_TWO_YEARS",
  "Absence Monitoring by Department": "CT_ABSENCE_MONITORING_BY_DEPARTMENT",
  "Absence Monitoring by Manager": "CT_ABSENCE_MONITORING_BY_MONITORING",

  // Employee Focus List
  "Top 100 Working Days Lost in Last 12 Months": "EFL_TOP_WORKING_DAYS_LAST_YEAR",
  "Top 100 Absence Spells in Last 12 Months": "EFL_TOP_ABSENCE_SPELLS_LAST_YEAR",
  "Top 25 Mental Health Absences in Last 12 Months": "EFL_TOP_MENTAL_HEALTH_ABSENCES_LAST_YEAR",
  "Top 25 Work Related Absences in Last 12 Months": "EFL_TOP_WORK_ABSENCES_LAST_YEAR",
  "Top 500 COVID-19 Days Lost in Last 12 Months": "EFL_TOP_COVID_ABSENCES_LAST_YEAR",
  "Top 100 Least Absences in Last 12 Months": "EFL_LEAST_ABSENCES_LAST_YEAR",

  // Department Focus List
  "Top 10 Absence Rate in Last 12 Months": "DFL_TOP_ABSENCE_RATE_LAST_YEAR",
  "Top 10 Working Days Lost in Last 12 Months": "DFL_TOP_WORKING_DAYS_LAST_YEAR",
  "Top 10 Absence Spells in Last 12 Months": "DFL_TOP_ABSENCE_SPELLS_LAST_YEAR",
  "Top 50 Highest RTW Compliance in Last 12 Months": "DFL_TOP_RTW_COMPLIANCE_LAST_YEAR",
  "Top 50 Lowest RTW Compliance in Last 12 Months": "DFL_LOWEST_RTW_COMPLIANCE_LAST_YEAR",
  "Top 100 COVID-19 Absences in Last 12 Months": "DFL_TOP_COVID_ABSENCES_LAST_YEAR",

  // Manager Focus List
  "Top 10 Highest RTW Compliance": "MFL_TOP_RTW_COMPLIANCE",
  "Top 10 Lowest RTW Compliance": "MFL_LOWEST_RTW_COMPLIANCE",
  "Top 10 Most Logins": "MFL_TOP_MOST_LOGINS",
  "Most Outstanding Actions": "MFL_TOP_ACTIONS",

  // Absence Monitoring
  "Employee Absence Monitoring Status": "AM_EMPLOYEE_STATUS",
  "Employees Who Have Never Been In Process": "AM_UNPROCESSED_EMPLOYEES",
  "Outstanding Alert Reviews": "AM_ALERT_REVIEWS",
};
